import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps {
  noPadding?: boolean;
  noMargin?: boolean;
  spaced?: boolean;
  bold?: boolean;
  gray?: boolean;
}

const Title = styled.h1`
  font-size: 5rem;
  padding-bottom: 5rem;
  margin-top: 2rem;
  color: ${theme.color.primary};

  // noMargin
  ${({ noMargin }) => (noMargin ? `margin: 0;` : ``)}

  // Basic
    font-family: ${theme.fontFamily.bold};


  // Bold
  ${({ bold }) =>
    bold
      ? `
    font-family: ${theme.fontFamily.black};
  `
      : ``};
    // Gray
  ${({ gray }) =>
    gray
      ? `
    color: ${theme.color.gray.dark};
  `
      : ``};
  ${({ spaced }: IProps) => (spaced ? `margin-bottom: 90px` : ``)}
  // No Padding
  ${({ noPadding }: IProps) =>
    noPadding ? `padding-bottom: 0; margin-top: 0` : ``};
`;

export default Title;



// WEBPACK FOOTER //
// ./src/components/common/Title.tsx